module.exports = __webpack_public_path__ + "static/media/adolescent-programs.380f964b.svg";